// extracted by mini-css-extract-plugin
export default {"registerMain":"AuthScreen_registerMain__AFiYN","authRoot":"AuthScreen_authRoot__Yy4FW","registerPolicy":"AuthScreen_registerPolicy__9S0hF"};